import React from "react";
import classes from "./ResultSet.module.css";
import { useTranslation } from 'react-i18next';
const fieldnames = ["Idx", "Shiny", "Date", "HP", "ATK", "DEF", "SPA", "SPD", "SPE", "Nature", "Ability", "Gender", "Seed", "EC", "PID"];
const ResultSet = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();
    const headlines = [t("misc:FRAMEADVANCES"), t("misc:SHINYNESS"), t("misc:DATE"), t("stats.HP"), t("stats.ATK"), t("stats.DEF"), t("stats.SPA"), t("stats.SPD"), t("stats.SPE"), t("misc:NATURE"), t("misc:ABILITY"), t("misc:GENDER"), t("misc:SEED"), "EC", "PID"];
        const header = headlines.map((v, idx) => <th key={idx} className={classes.TableHead}>{v}</th>);
    let body = <tr className={classes.ContentNotFound}><td colSpan={headlines.length}>{t("misc:NORESULT")}</td></tr>
    if(props.results.length > 0) {
        body = props.results.map(
            (entry, idx) => {
                return <tr key={idx} className={(idx&1)===0?classes.TDEven:classes.TDOdd}>
                    {fieldnames.map((v, i) => {
                        return <td key={idx+"."+i}>{props.results[idx][v]}</td>
                    })}
                </tr>
            }
        )
    }
    return (
        <div className={classes.Wrapper}>
            <table className={classes.Table}>
                <thead>
                    <tr>
                        {header}
                    </tr>
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>
    );
}

export default React.memo(ResultSet);